/**
 * Disclosure field name constants
 * These constants ensure consistency across validation, forms, and other disclosure-related code
 */

// Boolean fields
export const FIELD_HAS_HOMICIDE = 'hasHomicide'
export const FIELD_IS_REGISTERED_PLACE = 'isRegisteredPlace'
export const FIELD_IS_AFFECTED_WITH_RELEVANT_AUTHORITIES =
  'isAffectedWithRelevantAuthorities'
export const FIELD_HAS_ASBESTOS = 'hasAsbestos'
export const FIELD_COMPLIES_WITH_MINIMUM_STANDARDS =
  'compliesWithMinimumStandards'
export const FIELD_IS_BEING_SOLD = 'isBeingSold'
export const FIELD_HAS_EMBEDDED_NETWORK = 'hasEmbeddedNetwork'

// Version 3 boolean fields
export const FIELD_HAS_ENGAGED_AGENT_TO_SELL = 'has_engaged_agent_to_sell'
export const FIELD_HAS_CONTRACT_OF_SALE_PREPARED =
  'has_contract_of_sale_prepared'
export const FIELD_HAS_MORTGAGEE_ACTION = 'has_mortgagee_action'
export const FIELD_MORTGAGEE_HAS_COMMENCED_PROCEEDINGS =
  'mortgagee_has_commenced_proceedings'
export const FIELD_IS_PROPERTY_OWNER = 'is_property_owner'
export const FIELD_HAS_RIGHT_TO_RENT = 'has_right_to_rent'
export const FIELD_HAS_MOULD_DAMP_REPAIR_NOTICE_3YR =
  'has_mould_damp_repair_notice_3yr'
export const FIELD_HAS_OUTSTANDING_SAFETY_RECOMMENDATIONS =
  'has_outstanding_safety_recommendations'
export const FIELD_IS_HERITAGE_LISTED = 'is_heritage_listed'
export const FIELD_HAS_DRUG_USAGE_5YR = 'has_drug_usage_5yr'
export const FIELD_HAS_DEFECT_SAFETY_CONCERN_NOTICE =
  'has_defect_safety_concern_notice'
export const FIELD_HAS_DOMESTIC_BUILDING_DISPUTE =
  'has_domestic_building_dispute'
export const FIELD_HAS_OWNERS_CORPORATION_DISPUTE =
  'has_owners_corporation_dispute'
export const FIELD_HAS_OWNERS_CORPORATION_RULES = 'has_owners_corporation_rules'

// Date fields
export const FIELD_DATE_OF_HOMICIDE = 'dateOfHomicide'
export const FIELD_DATE_OF_REPAIR_NOTICE = 'dateOfRepairNotice'
export const FIELD_DATE_OF_DRUG_USAGE = 'dateOfDrugUsage'
export const FIELD_DATE_OF_GAS_CHECK = 'dateOfGasCheck'
export const FIELD_DATE_OF_ELECTRICITY_CHECK = 'dateOfElectricityCheck'
export const FIELD_DATE_OF_POOL_CHECK = 'dateOfPoolCheck'

// Embedded network fields
export const FIELD_EMBEDDED_NETWORK_NAME = 'embeddedNetworkName'
export const FIELD_EMBEDDED_NETWORK_ABN = 'embeddedNetworkAbn'
export const FIELD_EMBEDDED_NETWORK_PHONE = 'embeddedNetworkPhone'
export const FIELD_EMBEDDED_NETWORK_PRICING = 'embeddedNetworkPricing'
export const FIELD_EMBEDDED_NETWORK_WEBSITE = 'embeddedNetworkWebsite'

// Other fields
export const FIELD_FURTHER_INFORMATION = 'further_information'
export const FIELD_OWNERS_CORPORATION_RULES_ATTACHMENT =
  'owners_corporation_rules_attachment'

// Validation messages
export const VALIDATION_MESSAGE_REQUIRED = 'Please answer this question'
export const VALIDATION_MESSAGE_FURTHER_INFO_REQUIRED =
  'Please provide further information as required'
export const VALIDATION_MESSAGE_ATTACHMENT_REQUIRED =
  'Please attach the owners corporation rules document'
